import BaseCommand from "@/models/api/commands/BaseCommand";

export class SaveOrderCommand extends BaseCommand {
  CommandName = "SaveOrder";
}
